import { COOKIES } from './constants';
import { getCookieValue } from './index';

export const getBrazeDeviceId = async (): Promise<string | undefined> => {
    const id = await getCookieValue(COOKIES.BRAZE_DEVICE_ID);
    return id || undefined;
};
